import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect, useState } from 'react';

const useSetupAxios = (instance) => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [isAxiosReady, setAxiosIsReady] = useState(false);

  instance.defaults.baseURL = process.env.REACT_APP_API_URL;

  const setAxios = useCallback(
    (getToken) => {
      instance.interceptors.request.use(
        async function (config) {
          try {
            const accessToken = await getToken();
            // On the request itself: axios-retry replays a config whose headers axios already flattened, where a
            // top-level Authorization from the first attempt would override a new one set on headers.common.
            config.headers.Authorization = `Bearer ${accessToken}`;
            return config;
          } catch (e) {
            console.error(e);
          }
        },
        function (error) {
          return Promise.reject(error);
        }
      );
      setAxiosIsReady(true);
    },
    [instance.interceptors.request]
  );

  useEffect(() => {
    if (isAuthenticated) {
      setAxios(getAccessTokenSilently);
    }
  }, [isAuthenticated, setAxios, getAccessTokenSilently]);

  return [isAxiosReady];
};

export default useSetupAxios;
